export default "__VITE_ASSET__O882oClY__"